import React, { useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from 'styles';

import AutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';

import api from 'services';
import MapComponent from './Map';
import constants from 'constants';
import BasicChip from '../../Base/Chips/BasicChip';

const menuSeparatorStyle = {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '36px',
    gap: '10px',
    color: '#9E9E9E',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '18px',
    minHeight: '24px',
};

const MergingPorts = ({
    mergePorts,
    addValue,
    disabledBtn,
    clearPorts,
    sourcePort,
}) => {
    const [sourceObject, setSourceObject] = useState({ name: '' });
    const [sourceItems, setSourceItems] = useState([]);
    const [destinationObject, setDestinationObject] = useState({ name: '' });
    const [destinationItems, setDestinationItems] = useState([]);

    useEffect(() => {
        if (clearPorts) {
            setSourceObject({ name: '' });
            setSourceItems([]);
            setDestinationObject({ name: '' });
            setDestinationItems([]);
        }
    }, [clearPorts]);

    useEffect(() => {
        if (clearPorts) return;
        setSourceObject(sourcePort);
    }, [sourcePort, clearPorts]);

    const merge = useCallback(() => {
        mergePorts();
    }, [mergePorts]);

    const updateInputSource = useCallback((searchText, searchOpts = {}) => {
        const newSourceObject = { name: searchText };
        setSourceObject(newSourceObject);

        addValue('sourcePort', {});

        if (searchText.length <= 1) {
            return;
        }

        api.findPortAdmin({ name: searchText, withAreasWithChild: true, ...searchOpts })
            .then((response) => {
                if (response.status === 200) {
                    const newSourceItems = [];
                    response.data.data.forEach((item) => {
                        newSourceItems.push({
                            name: `${item.name} ${item.country ? `(${item.country.name})` : ''}`,
                            item: (<MenuItem
                                style={{ width: '100%' }}
                                primaryText={
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span>{`${item.name} ${item.country ? `(${item.country.name})` : ''}`}</span>
                                        {item.addedBy && <BasicChip label="User" />}
                                    </div>
                                }
                                item={item}
                            />),
                        });

                        if (item.alt && item.alt.length > 0) {
                            newSourceItems.push({
                                name: 'ALTERNATIVE NAME',
                                item: <MenuItem
                                    disabled
                                    primaryText="ALTERNATIVE NAME"
                                    style={{ ...menuSeparatorStyle }}
                                />,
                            });
                            item.alt.forEach((alternativeName) => {
                                newSourceItems.push({
                                    name: `${alternativeName}`,
                                    item: (<MenuItem
                                        style={{ width: '100%', padding: '0 0 0 20px' }}
                                        primaryText={`${alternativeName}`}
                                        item={item}
                                    />),
                                });
                            });
                        }

                        if (item.sub && item.sub.length > 0) {
                            newSourceItems.push({
                                name: 'SUB PORTS',
                                item: <MenuItem disabled primaryText="SUB PORTS" style={menuSeparatorStyle} />,
                            });
                            item.sub.forEach((subPort) => {
                                newSourceItems.push({
                                    name: `${subPort.name} ${item.country ? `(${item.country.name})` : ''}`,
                                    item: (<MenuItem
                                        style={{ width: '100%', padding: '0 0 0 20px' }}
                                        primaryText={`${subPort.name} ${item.country ? `(${item.country.name})` : ''}`}
                                        item={subPort}
                                    />),
                                });
                            });
                        }
                    });

                    setSourceItems(newSourceItems);
                    document.body.scrollTop = document.body.scrollTop + 1;
                    document.body.scrollTop = document.body.scrollTop - 1;
                }
            });
    }, [addValue]);

    const updateInputDestination = useCallback((searchText) => {
        const newDestinationObject = { name: searchText };
        setDestinationObject(newDestinationObject);

        addValue('destinationPort', {});

        if (searchText.length <= 1) {
            return;
        }

        api.findPortAdmin({ name: searchText })
            .then((response) => {
                if (response.status === 200) {
                    const newDestinationItems = [];
                    response.data.data.forEach((item) => {
                        newDestinationItems.push({
                            name: `${item.name} ${item.country ? `(${item.country.name})` : ''}`,
                            item: (<MenuItem
                                style={{ width: '100%' }}
                                primaryText={`${item.name} ${item.country ? `(${item.country.name})` : ''}`}
                                item={item}
                            />),
                        });

                        if (item.alt && item.alt.length > 0) {
                            newDestinationItems.push({
                                name: 'ALTERNATIVE NAME',
                                item: <MenuItem disabled primaryText="ALTERNATIVE NAME" style={menuSeparatorStyle} />,
                            });
                            item.alt.forEach((alternativeName) => {
                                newDestinationItems.push({
                                    name: `${alternativeName}`,
                                    item: (<MenuItem
                                        style={{ width: '100%', padding: '0 0 0 20px' }}
                                        primaryText={`${alternativeName}`}
                                        item={item}
                                    />),
                                });
                            });
                        }

                        if (item.sub && item.sub.length > 0) {
                            newDestinationItems.push({
                                name: 'SUB PORTS',
                                item: <MenuItem disabled primaryText="SUB PORTS" style={menuSeparatorStyle} />,
                            });
                            item.sub.forEach((subPort) => {
                                newDestinationItems.push({
                                    name: `${subPort.name} ${item.country ? `(${item.country.name})` : ''}`,
                                    item: (<MenuItem
                                        style={{ width: '100%', padding: '0 0 0 20px' }}
                                        primaryText={`${subPort.name} ${item.country ? `(${item.country.name})` : ''}`}
                                        item={subPort}
                                    />),
                                });
                            });
                        }
                    });

                    setDestinationItems(newDestinationItems);
                    document.body.scrollTop = document.body.scrollTop + 1;
                    document.body.scrollTop = document.body.scrollTop - 1;
                }
            });
    }, [addValue]);

    const onUpdateInput = useCallback((searchText, type) => {
        switch (type) {
        case 'source':
            updateInputSource(searchText, { withUserPorts: true });
            break;
        case 'destination':
            updateInputDestination(searchText);
            break;
        default:
            break;
        }
    }, [updateInputSource, updateInputDestination]);

    const onChooseSource = useCallback((updateProperties) => {
        if (typeof updateProperties === 'string' && sourceItems.length > 0) {
            const newSourceObject = sourceItems[0].item.props.item;
            setSourceObject(newSourceObject);
            setSourceItems([]);
            addValue('sourcePort', newSourceObject);
            return;
        }

        if (!updateProperties || typeof updateProperties === 'string') {
            return;
        }

        const newSourceObject = updateProperties.item.props.item;
        setSourceObject(newSourceObject);
        setSourceItems([]);
        addValue('sourcePort', newSourceObject);
    }, [addValue, sourceItems]);

    const onChooseDestination = useCallback((updateProperties) => {
        if (typeof updateProperties === 'string' && destinationItems.length > 0) {
            const newDestinationObject = destinationItems[0].item.props.item;
            setDestinationObject(newDestinationObject);
            setDestinationItems([]);
            addValue('destinationPort', newDestinationObject);
            return;
        }

        if (!updateProperties || typeof updateProperties === 'string') {
            return;
        }

        const newDestinationObject = updateProperties.item.props.item;
        setDestinationObject(newDestinationObject);
        setDestinationItems([]);
        addValue('destinationPort', newDestinationObject);
    }, [addValue, destinationItems]);

    const onChooseAutoComplete = useCallback((updateProperties, type) => {
        switch (type) {
        case 'source':
            onChooseSource(updateProperties);
            break;
        case 'destination':
            onChooseDestination(updateProperties);
            break;
        default:
            break;
        }
    }, [onChooseSource, onChooseDestination]);

    return (
        <div>
            <div className="row">
                <h3 className='col-xs-3'>
                    Port or area to port
                </h3>
            </div>
            <div className="row">
                <div className='col-xs-4'>
                    <p style={{ fontSize: '12px' }}>
                        Auto Complete area and ports (Search fields are name, alt name). <br />
                    </p>
                    <AutoComplete
                        textFieldStyle={styles.autoCompleteCSS}
                        floatingLabelText='Source'
                        searchText={sourceObject.name}
                        dataSource={sourceItems}
                        dataSourceConfig={{ text: 'name', value: 'item' }}
                        onUpdateInput={(searchText) => { onUpdateInput(searchText, 'source'); }}
                        onNewRequest={(chosenRequest) => { onChooseAutoComplete(chosenRequest, 'source'); }}
                        filter={AutoComplete.noFilter}
                        style={{ width: '100%' }}
                        listStyle={{ maxHeight: '300px', overflow: 'auto' }}
                        fullWidth
                        popoverProps={{
                            canAutoPosition: true,
                            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                            targetOrigin: { horizontal: 'left', vertical: 'top' },
                        }}
                    />
                </div>
                <div className='col-xs-4'>
                    <p style={{ fontSize: '12px' }}>
                        Auto Complete only ports (Search fields are name, alt name). <br />
                    </p>
                    <AutoComplete
                        textFieldStyle={styles.autoCompleteCSS}
                        floatingLabelText='Destination'
                        searchText={destinationObject.name}
                        dataSource={destinationItems}
                        dataSourceConfig={{ text: 'name', value: 'item' }}
                        onUpdateInput={(searchText) => { onUpdateInput(searchText, 'destination'); }}
                        onNewRequest={(chosenRequest) => { onChooseAutoComplete(chosenRequest, 'destination'); }}
                        filter={AutoComplete.noFilter}
                        style={{ width: '100%' }}
                        listStyle={{ maxHeight: '300px', overflow: 'auto' }}
                        fullWidth
                        popoverProps={{
                            canAutoPosition: true,
                            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                            targetOrigin: { horizontal: 'left', vertical: 'top' },
                        }}
                    />
                </div>
                <div className='col-xs-4'>
                    <RaisedButton
                        primary
                        disabled={disabledBtn}
                        label='merge ports'
                        onClick={merge}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-4">
                    {
                        sourceObject.country ?
                            !sourceObject.coordinates ? null : <MapComponent
                                coordinates={sourceObject.coordinates}
                                type='ports'
                                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                                loadingElement={<div style={{ height: '100%' }} />}
                                containerElement={<div style={{ height: '300px' }} />}
                                mapElement={<div style={{ height: '100%' }} />}
                            />
                            :
                            !sourceObject.childs || sourceObject.childs.length === 0 ? null : <MapComponent
                                coordinates={sourceObject.childs}
                                type="area"
                                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                                loadingElement={<div style={{ height: '100%' }} />}
                                containerElement={<div style={{ height: '300px' }} />}
                                mapElement={<div style={{ height: '100%' }} />}
                                areaPolygon={sourceObject.areaCoordinates}
                            />
                    }
                    {
                        sourceObject.childs && sourceObject.childs.length === 0 ?
                            'Area doesn`t has ports'
                            :
                            ''
                    }

                </div>
                <div className="col-xs-4">
                    {
                        !destinationObject.coordinates ? null : <MapComponent
                            coordinates={destinationObject.coordinates}
                            type="ports"
                            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.GOOGLE_MAP_API_KEY}`}
                            loadingElement={<div style={{ height: '100%' }} />}
                            containerElement={<div style={{ height: '300px' }} />}
                            mapElement={<div style={{ height: '100%' }} />}
                            areaPolygon={sourceObject.areaCoordinates}
                        />
                    }
                </div>
            </div>
        </div>
    );
};

export default connect(
    (state, {
        mergePorts, addValue, disabledBtn, clearPorts, sourcePort,
    }) => ({
        mergePorts,
        addValue,
        disabledBtn,
        clearPorts,
        sourcePort,
    }),
    dispatch => bindActionCreators(
        {
        },
        dispatch,
    ),
)(MergingPorts);



// WEBPACK FOOTER //
// ./app/components/Regions/Merging/Ports.jsx